'use client'

import { Box, Typography, Paper } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { getTranslations, Link } from '@/lib/next-shim'

export function TermsAndConditionsPage() {
  const t = getTranslations('page.Terms')
  return (
    <Box component="main" sx={{ maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 3 }, py: { xs: 4, sm: 6 } }}>
      <Typography variant="h4" sx={{ fontWeight: 800, color: 'text.primary', mb: 1.5 }}>
        {t('title')}
      </Typography>
      <Box sx={{ height: 5, width: 56, bgcolor: 'primary.main', borderRadius: 4, mb: 4 }} />

      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {t('subtitle')}
      </Typography>

      <Paper elevation={0} sx={{ p: 3, mb: 4, borderRadius: 3, bgcolor: 'grey.50', border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="body1" color="text.secondary">
          {t('contactNote')}
        </Typography>
      </Paper>

      <Link href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'inherit', fontWeight: 600 }}>
        <ArrowBackIcon fontSize="small" />
        {t('backHome')}
      </Link>
    </Box>
  )
}
